import { connect } from 'react-redux';

import { 
    giveConsentToCookies,
    setPropyCookieValue
} from '../state/actions';

import CookieManager from '../components/CookieManager';

const mapStateToProps = (state) => ({
    
})
  
const mapDispatchToProps = {
    giveConsentToCookies,
    setPropyCookieValue,
}
  
const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(CookieManager)